export const en = {
    'title': 'Create call',
    'back-link-title': 'To the home page',
    'templates-title': 'Apply template',
    'mobile-templates-title-closed': 'Show the list of templates',
    'mobile-templates-title-opened': 'Hide the list of templates',
    'create-call-screen-title': 'Create call',
    'without-name': 'Without name',
};
